import { IApplicationState } from '../../../types/redux';
import { ITopJK } from '../../../types/top_three';

export const selectPopularJks = (state: IApplicationState): ITopJK[] => {
  return state.mainpage.popularJks || [];
};
